/*
    GET BROWSER INFO
    Return browser name and version
*/
export function AnalyzeBrowser(callback) {
  const UA = navigator.userAgent;
  let browser = null;
  let version = null;
  let versionMarker = null;

  //safari
  if (UA.indexOf("Safari") !== -1 && UA.indexOf("Chrome") === -1) {
    browser = "safari";
    versionMarker = "Version/";
  }

  //chrome
  if (
    UA.indexOf("Chrome") !== -1 &&
    UA.indexOf("Chromium") === -1 &&
    UA.indexOf("Edge") === -1
  ) {
    browser = "chrome";
    versionMarker = "Chrome/";
  }

  //firefox
  if (UA.indexOf("Firefox") !== -1 && UA.indexOf("Seamonkey") === -1) {
    browser = "firefox";
    versionMarker = "Firefox/";
  }

  //IE 10 and below
  if (UA.indexOf("MSIE ") !== -1) {
    browser = "IE";
    versionMarker = "MSIE ";
    version = UA.substr(UA.indexOf(versionMarker) + versionMarker.length);
    version = version.substr(0, version.indexOf(";"));
  }
  //IE 11
  if (UA.indexOf("Trident") !== -1) {
    browser = "IE";
    versionMarker = "rv:";
    version = UA.substr(UA.indexOf(versionMarker) + versionMarker.length);
    version = version.substr(0, version.indexOf(")"));
  }
  //Edge
  if (UA.indexOf("Edge") !== -1) {
    browser = "edge";
    versionMarker = "Edge/";
  }

  if (browser !== "IE") {
    version = UA.substr(UA.indexOf(versionMarker) + versionMarker.length);
    if (version.indexOf(" ") > 0) {
      version = version.substr(0, version.indexOf(" "));
    }
  }

  version = version.split(".");
  version = parseInt(version[0], 10);

  console.log(browser, version);

  if (typeof callback === "function") {
    callback(browser, version);
  }
}

/*
    STORE DATA
    Save data into browser local storage
*/
export function StoreData(key, value, type) {
  console.log("store data", key);

  if (typeof type === "undefined") {
    type = "local";
  }
  if (type === "local") {
    localStorage[key] = JSON.stringify(value);
  }
  if (type === "session") {
    sessionStorage[key] = JSON.stringify(value);
  }
}

/*
    GET DATA
    Get data from browser local storage
*/
export function GetData(key, type) {
  if (typeof type === "undefined") {
    type = "local";
  }
  if (type === "local") {
    return JSON.parse(localStorage.getItem(key));
  }
  if (type === "session") {
    return JSON.parse(sessionStorage.getItem(key));
  }
}

/*
    SHUFFLE ARRAY
    Randomize order of array elements
*/
export function ShuffleArray(array) {
  return array
    .map(a => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map(a => a[1]);
}

/*
    SORT ARRAY OF OBJECTS BY KEY
*/
export function SortArray(array, key) {
  return array.reduce(function(result, item) {
    result[item[key]] = result[item[key]] || []; //build new array or find existing
    result[item[key]].push(item);
    return result;
  }, Object.create(null));
}

/*
    Scroll to Item
*/
export function ScrollTo(item) {
  if (item !== null) {
    const isSmoothScrollSupported =
      "scrollBehavior" in document.documentElement.style;
    const itemTop = window.scrollTop + item.getBoundingClientRect().top - 150;
    if (isSmoothScrollSupported) {
      window.scroll({
        top: itemTop,
        left: 0,
        behavior: "smooth"
      });
    } else {
      window.scrollTo(itemTop, 0);
    }
  }
}

/*
    Scroll to position on page
*/
export function ScrollToPosition(top, behavior = "auto") {
  const isSmoothScrollSupported =
    "scrollBehavior" in document.documentElement.style;
  if (isSmoothScrollSupported) {
    window.scroll({
      top: top,
      left: 0,
      behavior: behavior
    });
  } else {
    window.scrollTo(top, 0);
  }
}

//page show
export function ShowPage(scrollToTop = true) {
  //console.log( scrollToTop );
  if (scrollToTop === true) {
    ScrollToPosition(0);
  }
  //document.getElementById( "pageContent" ).style.opacity = 1;
}

//page leave
export function HidePage() {
  //document.getElementById( "pageContent" ).style.opacity = 0;
}

/*
    Check if item is visible in viewport
*/
export function CheckVis(item, margin, amount = "top") {
  let scrollTop = 0;
  if (typeof window.scrollTop !== "undefined") {
    scrollTop = window.scrollTop;
  }

  if (typeof margin === "undefined") {
    margin = 0;
  }
  if (margin === "halfScreen") {
    margin = window.innerHeight / 2;
  }
  if (margin === "thirdScreen") {
    margin = window.innerHeight / 3;
  }
  if (margin === "quarterScreen") {
    margin = window.innerHeight / 4;
  }
  if (margin === "eighthScreen") {
    margin = window.innerHeight / 8;
  }

  let itemTop = 0;
  if (typeof item !== "undefined" && item !== null) {
    itemTop = parseInt(
      item.getBoundingClientRect().top + scrollTop, //Gets position relative to viewport //Add scroll distance in to get position relative to document
      10
    );
  }

  if (amount === "top") {
    if (scrollTop + window.innerHeight > itemTop + margin) {
      return true;
    } else {
      return false;
    }
  }
}

/*
    Return appropriately sized image
*/
export function BuildImagePath(name, type, sizes) {
  let screen = 1200;
  if (window.innerWidth !== "undefined") {
    screen = window.innerWidth;
  }
  let size = sizes.filter(s => {
    return s.w > screen;
  })[0];
  let imagePath = `/img/${type}/${size.name}/${name}`;
  return imagePath;
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.js